import React, { useEffect, useState } from "react";
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Layout from "./Layout";
import customerDetailsStyles from "assets/jss/material-kit-pro-react/views/cspDashboard/customerDetailsStyles.js";
import { makeStyles } from "@material-ui/core";
import Button from "components/CustomButtons/Button.js";
import get from "lib/requests";
import { ErrorMessage } from "components/Common/toastify";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import classNames from "classnames";
import Loading from "components/Common/loading";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import { useNavigate } from "react-router-dom";
import Datetime from "react-datetime";
import moment from "moment";
import { useSelector } from "react-redux";

const useStylesCustomerDetailsStyles = makeStyles(customerDetailsStyles);

export default function InvoicesPage() {
	const classesCSStyles = useStylesCustomerDetailsStyles();
	const [loading, setLoading] = useState(false);
	const userInfo = useSelector((state) => state.user);
	const [startDate, setStartDate] = useState(moment()); // Today
	const [endDate, setEndDate] = useState(moment().add(1, "month")); // +1 month
	const navigate = useNavigate();

	const today = moment();
	const maxEndDate = moment().add(1, "month");

	const validStartDate = (current) => {
		return current.isSameOrAfter(today, "day");
	};

	const validEndDate = (current) => {
		return (
			current.isSameOrAfter(moment(startDate), "day") &&
			current.isSameOrBefore(maxEndDate, "day")
		);
	};
	useEffect(() => {}, [userInfo]);

	const getLicenseUseReport = async () => {
		setLoading(true);
		try {
			await get(
				`/api/license-use-report?startdate=${startDate}&enddate=${endDate}`,
				true
			)
				.then((res) => {
					if (res.data.success) {
						window.open(res.data.records.downloadpath, "_blank");
					} else {
						const errorMsg =
							res.data.errors?.map((error) => error).join(", ") || res.data.message;
						console.log(errorMsg, "errorMsg");
						ErrorMessage("License Use", errorMsg);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("License Use", message);
					setLoading(false);
				});
		} catch (error) {
			ErrorMessage("License Use", "Something went wrong try again!!");
			setLoading(false);
		}
	};

	const getLicenseUseDailyReport = async () => {
		setLoading(true);
		try {
			await get(
				`/api/license-use-daily-report?startdate=${startDate}&enddate=${endDate}`,
				true
			)
				.then((res) => {
					if (res.data.success) {
						window.open(res.data.records.downloadpath, "_blank");
					} else {
						const errorMsg =
							res.data.errors?.map((error) => error).join(", ") || res.data.message;
						console.log(errorMsg, "errorMsg");
						ErrorMessage("License Use", errorMsg);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("License Use", message);
					setLoading(false);
				});
		} catch (error) {
			ErrorMessage("License Use", "Something went wrong try again!!");
			setLoading(false);
		}
	};

	const getLicenseExportAsperTenant = async () => {
		setLoading(true);
		try {
			await get(
				`/api/license-export-asper-tenant?startdate=${startDate}&enddate=${endDate}`,
				true
			)
				.then((res) => {
					if (res.data.success) {
						window.open(res.data.records.downloadpath, "_blank");
					} else {
						const errorMsg =
							res.data.errors?.map((error) => error).join(", ") || res.data.message;
						console.log(errorMsg, "errorMsg");
						ErrorMessage("License Assignment Per User Per Tenant", errorMsg);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("License Assignment Per User Per Tenant", message);
					setLoading(false);
				});
		} catch (error) {
			ErrorMessage(
				"License Assignment Per User Per Tenant",
				"Something went wrong try again!!"
			);
			setLoading(false);
		}
	};
	const downloadCurrentSubscriptionList = async () => {
		setLoading(true);
		try {
			await get(`/api/download-annuity-report`, true)
				.then((res) => {
					if (res.data.success) {
						window.open(res.data.records.downloadpath, "_blank");
					} else {
						const errorMsg =
							res.data.errors?.map((error) => error).join(", ") || res.data.message;
						console.log(errorMsg, "errorMsg");
						ErrorMessage("License Assignment Per User Per Tenant", errorMsg);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("License Assignment Per User Per Tenant", message);
					setLoading(false);
				});
		} catch (error) {
			ErrorMessage(
				"License Assignment Per User Per Tenant",
				"Something went wrong try again!!"
			);
			setLoading(false);
		}
	};

	console.log(userInfo, "userDetails");

	return (
		<div>
			<Header
				color="info"
				brand="Auscomp Cloud Services"
				links={<HeaderLinks dropdownHoverColor="info" />}
				fixed
			/>
			<Layout>
				<div className={classNames(classesCSStyles.mx5, classesCSStyles?.my10)}>
					<Card className={classNames(classesCSStyles.px5)}>
						<CardHeader className=""></CardHeader>
						<CardBody
							className={classNames(
								classesCSStyles.accountSection,
								classesCSStyles.my10
							)}>
							<GridContainer className={classNames(classesCSStyles.marginAuto)}>
								<GridItem xs={12} sm={4} md={4}>
									<Button
										className={classesCSStyles?.mx5}
										color="primary"
										type="button"
										onClick={downloadCurrentSubscriptionList}>
										Download Current Subscription List
									</Button>
								</GridItem>
								<GridItem xs={12} sm={8} md={8}>
									<div className={classesCSStyles?.editBtns}>
										<Button
											color="info"
											size="sm"
											type="button"
											onClick={() => {
												// navigate("/csp-dashboard");
												window.location.href = "/csp-dashboard";
											}}>
											Back {">"}
										</Button>
									</div>
								</GridItem>
							</GridContainer>
							<GridContainer className={classNames(classesCSStyles.marginAuto)}>
								<GridItem
									xs={12}
									sm={12}
									md={12}
									className={classNames(
										classesCSStyles.rightSideBorder,
										loading ? classesCSStyles.loading : ""
									)}>
									{loading && (
										<Loading
											width={30}
											height={30}
											className={classesCSStyles.absoluteLoading}
										/>
									)}
									<GridContainer className={classNames(classesCSStyles.marginAuto)}>
										<GridItem xs={12} sm={12} md={12}>
											<hr />
										</GridItem>
										<GridItem xs={12} sm={6} md={6}>
											<div className={classesCSStyles?.reportTitle}>License Use</div>
											<div className={classNames(classesCSStyles?.my10)}>
												<Datetime
													inputProps={{ placeholder: "From date" }}
													dateFormat="MM/DD/YYYY"
													timeFormat={false}
													value={startDate}
													onChange={setStartDate}
													isValidDate={validStartDate}
												/>
											</div>

											<div className={classNames(classesCSStyles?.my10)}>
												<Datetime
													inputProps={{ placeholder: "To date" }}
													dateFormat="MM/DD/YYYY"
													timeFormat={false}
													value={endDate}
													onChange={setEndDate}
													isValidDate={validEndDate}
												/>
											</div>

											<div className={classNames(classesCSStyles?.my10)}>
												<Button
													color="info"
													size="sm"
													type="button"
													onClick={getLicenseUseReport}>
													Export
												</Button>

												<Button
													color="info"
													size="sm"
													type="button"
													onClick={getLicenseUseDailyReport}>
													Export Daily Report
												</Button>
											</div>
										</GridItem>
										{userInfo?.account_no == "70999" && (
											<GridItem xs={12} sm={6} md={6}>
												<div className={classesCSStyles?.reportTitle}>
													License Assignment Per User Per Tenant
												</div>
												<div className={classNames(classesCSStyles?.my10)}>
													<Datetime
														inputProps={{ placeholder: "From date" }}
														dateFormat="MM/DD/YYYY"
														timeFormat={false}
														value={startDate}
														onChange={setStartDate}
														isValidDate={validStartDate}
													/>
												</div>

												<div className={classNames(classesCSStyles?.my10)}>
													<Datetime
														inputProps={{ placeholder: "To date" }}
														dateFormat="MM/DD/YYYY"
														timeFormat={false}
														value={endDate}
														onChange={setEndDate}
														isValidDate={validEndDate}
													/>
												</div>

												<div className={classNames(classesCSStyles?.my10)}>
													<Button
														color="info"
														size="sm"
														type="button"
														onClick={getLicenseExportAsperTenant}>
														Export
													</Button>
												</div>
											</GridItem>
										)}
									</GridContainer>
								</GridItem>
							</GridContainer>
						</CardBody>
					</Card>
				</div>
			</Layout>
		</div>
	);
}
